import products from "./products"
const state = Object.keys(products).map((key, value) => (
    {
        name: products[key].name,
        type: products[key].type,
        count: 0,
        id: key,
        picture: products[key].picture,
        price: products[key].price,   // Add the actual price here
        desc: products[key].desc,   // Add the actual price here
        taste: products[key].taste,   // Add the actual price here
        variants: products[key].variants,
        usb: products[key].usb,   // Add the actual price here
        concentrate: products[key].concentrate,
        volume: products[key].volume,   // Add the actual price here

    }
))

export default state
